export default "__VITE_ASSET__CBlXZhJO__"